import { useState, type FormEvent } from 'react'
import { Link } from 'react-router-dom'
import { Store, CheckCircle } from 'lucide-react'
import { FloatingInput } from '@/components/FloatingInput'
import { supabase } from '@/lib/supabase'

export default function Register() {
  const [form, setForm] = useState({ nama: '', email: '', password: '' })
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)

  async function handleSubmit(e: FormEvent) {
    e.preventDefault()
    setLoading(true)
    setError('')

    const { error } = await supabase.auth.signUp({
      email: form.email,
      password: form.password,
      options: { data: { nama: form.nama } },
    })

    setLoading(false)

    if (error) {
      setError(error.message)
      return
    }

    setSuccess(true)
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-sm">

        {success ? (
          /* Success state */
          <div className="flex flex-col items-center text-center">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
              <CheckCircle size={32} className="text-green-500" />
            </div>
            <h1 className="text-xl font-bold text-gray-900">Pendaftaran Berhasil!</h1>
            <p className="text-sm text-gray-400 mt-2">
              Akun kamu sudah dibuat, {form.nama}.
            </p>
            <Link
              to="/login"
              className="mt-6 w-full py-3 rounded-xl bg-blue-600 text-white font-semibold text-sm hover:bg-blue-700 transition-colors text-center block"
            >
              Masuk Sekarang
            </Link>
            <Link to="/" className="mt-3 text-xs text-gray-400 hover:text-gray-600">
              ← Kembali ke beranda
            </Link>
          </div>
        ) : (
          /* Form state */
          <>
            <div className="flex flex-col items-center mb-8">
              <div className="w-12 h-12 bg-blue-600 rounded-2xl flex items-center justify-center mb-3">
                <Store size={24} className="text-white" />
              </div>
              <h1 className="text-xl font-bold text-gray-900">Daftar</h1>
              <p className="text-sm text-gray-400 mt-1">Buat akun baru</p>
            </div>

            <form onSubmit={handleSubmit} className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 flex flex-col gap-4">
              <FloatingInput
                label="Nama Lengkap"
                type="text"
                value={form.nama}
                onChange={e => setForm(f => ({ ...f, nama: e.target.value }))}
              />
              <FloatingInput
                label="Email"
                type="email"
                value={form.email}
                onChange={e => setForm(f => ({ ...f, email: e.target.value }))}
              />
              <FloatingInput
                label="Password"
                type="password"
                value={form.password}
                onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
              />

              {error && <p className="text-xs text-red-500 -mt-1">{error}</p>}

              <button
                type="submit"
                disabled={!form.nama || !form.email || !form.password || loading}
                className={`w-full py-3 rounded-xl font-semibold text-sm transition-colors ${
                  !form.nama || !form.email || !form.password || loading
                    ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                    : 'bg-blue-600 text-white hover:bg-blue-700'
                }`}
              >
                {loading ? 'Memproses...' : 'Daftar'}
              </button>
            </form>

            <p className="text-center text-sm text-gray-400 mt-4">
              Sudah punya akun?{' '}
              <Link to="/login" className="text-blue-600 font-medium hover:underline">
                Masuk
              </Link>
            </p>

            <div className="text-center mt-3">
              <Link to="/" className="text-xs text-gray-400 hover:text-gray-600">
                ← Kembali ke beranda
              </Link>
            </div>
          </>
        )}

      </div>
    </div>
  )
}
